import { BaseDto } from '../base.dto';
import { MerchantBriefDto } from '../merchant-brief.dto';
import { PosDeviceBriefDto } from '../pos-device-brief.dto';
import { UserBriefDto } from '../user-brief.dto';
import {
  IsDefined,
  IsInt,
  IsISO8601,
  IsNumber,
  IsOptional,
  IsString,
  Length,
  ValidateNested,
} from 'class-validator';
import { Exclude, Type } from 'class-transformer';
import { EmployeeBriefDto } from '../employee-brief.dto';

export class BankingCashCountCreateManyDto {
  @ValidateNested({each: true})
  @Type(() => BankingCashCountDto)
  bulk: BankingCashCountDto[];
}

export class BankingCashCountDto extends BaseDto {
  @IsOptional()
  @IsInt()
  posDeviceId?: number;

  @IsOptional()
  @IsInt()
  sweetFaceTerminalId?: number;

  @IsDefined()
  @IsInt()
  merchantId: number;

  @IsDefined()
  @IsInt()
  currencyId: number;

  @IsDefined()
  @IsNumber({maxDecimalPlaces: 2})
  value: number

  @IsDefined()
  @IsInt()
  quantity: number;

  @IsOptional()
  @IsInt()
  bags: number;

  @IsDefined()
  @IsString()
  @Length(1, 45)
  type: string;

  @IsDefined()
  @IsISO8601()
  day: string;

  @IsOptional()
  @IsString()
  @Length(1, 45)
  countedWhen: string;

  @IsDefined()
  @IsInt()
  countedTimes: number;

  @IsOptional()
  @IsInt()
  merchantServiceTimeId: number;

  @IsOptional()
  @Exclude()
  lastModifiedUser?: UserBriefDto;

  @IsOptional()
  @IsInt()
  lastModifiedEmployeeId: number;

  @IsOptional()
  @Exclude()
  lastModifiedEmployee?: EmployeeBriefDto;

  @IsOptional()
  @Exclude()
  merchant?: MerchantBriefDto;

  @IsOptional()
  @Exclude()
  posDevice?: PosDeviceBriefDto;
}
